<template>
    <div class="filter__block"
         v-if="!addressItems.loading && !addressItems.error">

            <div class="checkbox"
                 v-for="(item,index) in addressItems.list"
                 :key="index">
                <input class="checkbox__input"
                       type="checkbox"
                       :id="item.id"
                       :name="item.name"
                       :value="item.id"
                       v-model="checkboxModel"
                       :disabled="checkDis(item.id)"
                />
                <label class="address-radio__label checkbox__label"
                       :class="{disabled: checkDis(item.id)}"
                       :for="item.id">
                    <span class="checkbox__box"></span>
                    {{item.name}}
                </label>
            </div>
    </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'
  import vSelect from 'vue-multiselect'

  export default {
    name: "ScheduleFilterAddress",
    components: {
      vSelect
    },
    computed: {
      ...mapState([
        'addressItems',
        'filterAddress',
        'filterSearch',
        'urlDate',
      ]),
      ...mapGetters([
        'getFilteredScheduleListByDate',
        "getFilteredScheduleListBySearchAndDate"
      ]),
      checkboxModel: {
        get() {
          return this.filterAddress
        },
        set(value) {
          this.setFilterAddressModel(value)
        }
      },
      disabledAddress() {
        if (this.filterSearch.length >= 3) {
          return [...new Set(this.getFilteredScheduleListBySearchAndDate.map(itemList =>
            itemList.classes.map(itemClasses =>
              itemClasses.address.id)).flat(1))];
        } else {
          return [...new Set(this.getFilteredScheduleListByDate.map(itemList =>
            itemList.classes.map(itemClasses =>
              itemClasses.address.id)).flat(1))];
        }
      }
    },
    created() {
      if (this.urlDate.address) this.setFilterAddressModel(this.urlDate.address.map(item => Number(item)));
    },
    methods: {
      ...mapActions([
        'setFilterAddressModel',
      ]),
      checkDis(value) {
        return !this.disabledAddress.includes(value)
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
